import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Factura } from 'src/app/Models/factura/factura';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import * as moment from 'moment';
import * as saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { HttpResponse } from '@angular/common/http';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { DatePipe } from '@angular/common';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-ventas',
  templateUrl: './ventas.component.html',
  styleUrls: ['./ventas.component.css']
})
export class VentasComponent implements OnInit {
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(VentasComponent, null) impventas: VentasComponent;
  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public tipoinforme = 0;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 10000;
  public cliente: Cliente = new Cliente;
  public listclientes: Cliente[] = [];
  public alertType: AlertType = new AlertType();
  public facturas: Factura[] = [];
  public detfactus: DetalleFactura[] = [];
  public totalventas: number = 0;
  public totalefectivo: number = 0;
  public totaltarjetas: number = 0;
  public sumacantidad: number = 0;
  public sumatotal: number = 0;
  public empresa: any;
  public pagventas: any = 0;
  public today = new Date();
  public fechaHoraActual: Date = new Date()
  constructor(private data: DataService, private datePipe: DatePipe, private route: Router, private reportViewer: ReportViewerService) { }

  ngOnInit() {

  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.showTab(1);
    this.setInitialDates();
    this.getClientes();
    this.getEmpresa();
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.info.hide();
    }, 10);
  }

  showTab(i) {
    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }


  setInitialDates() {
    const today = new Date();
    this.rangofechas.fecfin = this.formatearFechas(today);

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.rangofechas.fecini = this.formatearFechas(firstDayOfMonth);
  }

  formatearFechas(fecha) {
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  async Ventas() {

    await this.GetData();
    // Llama a GetTotalVentas solo después de que GetData se haya completado
    await this.GetTotalVentas();
  }

  async VentasDetallado() {

    await this.GetDataDet();
    // Llama a GetTotalVentas solo después de que GetData se haya completado
    await this.GetTotalVentasDet();
  }

  setRango() {
    let fechainicio = this.formatearFechas(this.rangofechas.fecini);
    let fechafin = this.formatearFechas(this.rangofechas.fecfin);
    this.rangofechas.fecini = fechainicio;
    this.rangofechas.fecfin = fechafin;
  }

  async getClientes() {
    console.log("obteniendo clientes");
    await this.data.AsyncGetSimple(this.data.api.cliente).then(r => {
      this.listclientes = r;
    })
  }

  getEmpresa() {
    this.data.GetSimple(this.data.api.empresa).subscribe(r => {
      //console.log("Empresa:", r);
      this.empresa = r[0];
    }), (error) => {
      console.log(error);

    };
  }

  async GetData() {
    await this.data.PrintP(this.data.api.factura, this.rangofechas).then(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.facturas = r;
      }
    }).catch(e => { console.log(e) });
  }

  async GetDataDet() {
    await this.data.PrintP(this.data.api.detfactura, this.rangofechas).then(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.detfactus = r;
      }
    }).catch(e => { console.log(e) });
  }

  async GetTotalVentas() {
    this.facturas.forEach(factura => {
      this.totalventas += +factura.total
      this.totalefectivo += +factura.efectivo
      this.totaltarjetas += +factura.tarjetachq
    });
  }

  async GetTotalVentasDet() {
    this.detfactus.forEach(detalle => {
      this.sumacantidad += +detalle.cantidad
      this.sumatotal += +detalle.impnetoct
    });

  }

  async imprimirVenta() {
    console.log(this.rangofechas);
    const myobj = JSON.stringify(this.rangofechas);
    console.log(myobj);
    this.facturas = []
    this.detfactus = []
    this.sumatotal = 0
    this.sumacantidad = 0
    this.totalefectivo = 0
    this.totaltarjetas = 0
    this.totalventas = 0
    if (this.tipoinforme == 1) {
      await this.VentasDetallado()
      setTimeout(() => {
        const blob = this.printerVentasDetallado(); // Llama a printer después de 2 segundos
        if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Reporte de Ventas',
            `ventas_${fecha}.pdf`
          );
        }
      }, 1500);
    } else if (this.tipoinforme == 0) {

      await this.Ventas()
      setTimeout(() => {

        const blob = this.printerVentas(); // Llama a printer después de 2 segundos
        if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Reporte de Ventas Detallado',
            `ventas_detallado_${fecha}.pdf`
          );
        }
      }, 1500);

    }
  }


  printerVentas(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'INFORME DE VENTAS', x: 80, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'Numero', 'Razon Social', 'Estado', 'Mon', 'Tipo de cambio', 'Total', 'Tarjeta', 'Efectivo'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#ventas tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        9: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 9,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Doc', data.settings.margin.left, data.cursor.y);
        doc.text('Serie', data.settings.margin.left, data.cursor.y);
        doc.text('Numero', data.settings.margin.left, data.cursor.y);
        doc.text('Razon Social', data.settings.margin.left + 40, data.cursor.y);
        doc.text('Estado', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Moneda', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Tipo de cambio', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Total', data.settings.margin.left + 140, data.cursor.y);
        doc.text('Tarjetas', data.settings.margin.left + 190, data.cursor.y);
        doc.text('Efectivo', data.settings.margin.left + 240, data.cursor.y);
      }
    });

    // Guardar el archivo PDF

    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  printerVentasDetallado(): Blob | null {
    const doc = new jsPDF('landscape');
    const titulo = { text: 'INFORME DE VENTAS DETALLADO', x: 100, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 225, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'Numero', 'Estado', 'Producto', 'Unidad', 'Cantidad', 'Precio', 'Moneda', 'Total'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#ventasdetallado tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        10: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 10,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 260, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(12);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Tipo', data.settings.margin.left, data.cursor.y);
        doc.text('Serie', data.settings.margin.left, data.cursor.y);
        doc.text('Numero', data.settings.margin.left, data.cursor.y);
        doc.text('Estado', data.settings.margin.left + 40, data.cursor.y);
        doc.text('Producto', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Unidad', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Cantidad', data.settings.margin.left + 140, data.cursor.y);
        doc.text('Precio', data.settings.margin.left + 190, data.cursor.y);
        doc.text('Moneda', data.settings.margin.left + 240, data.cursor.y);
        doc.text('Total', data.settings.margin.left + 290, data.cursor.y);

      }
    });

    // Guardar el archivo PDF

    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  close() {
    this.btnclose.nativeElement.click();
  }

  GenerarExcel() {
    let ruta = ""
    if (this.tipoinforme == 1) {
      ruta = this.data.api.detfactura;
    } else if (this.tipoinforme == 0) {
      ruta = this.data.api.factura;
    }
    this.data.GenerateExcel(ruta, this.rangofechas).subscribe(r => {
      console.log(r);

      if (r.download_url) {
        window.open(this.data.api.apiBaseUrl + 'api/download_excel' + r.download_url, '_blank');
        // Establecer un retraso antes de eliminar el archivo
        setTimeout(() => {
          this.data.DeleteExcel(r.download_url).subscribe(r => console.log(r));
        }, 20000); // 10000 milisegundos = 10 segundos
      }
    }, (error) => {
      this.data.notify("Error al generar excel", "Error", this.alertType.error);
    });
  }
}
